import { Button } from 'antd';
import styled from 'styled-components';

export const CreateButton = styled(Button)`
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 600;
	border-radius: 5px;
	padding: 0.8rem 0.8rem;
	background-color: #2f54eb;

	span:last-child {
		font-size: 1rem;
		line-height: 22px;
		margin-bottom: 0.2rem;
	}

	.anticon {
		display: flex;
		font-size: 1.2rem;
		align-items: center;
	}
`;
